import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-8'],
    padding: '0 75px',
  },
  containerEditable: {
    padding: 0,
  },
  title: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-3'],
    lineHeight: typography['lineHeightBody-3'],
    color: palette['greyWhite'],
  },
  addButton: {
    width: '100%',
  },
  buttons: {
    display: 'flex',
    gap: anatomy['space-32'],
  },
  button: {
    border: 'none',
    outline: 'none',
    display: 'flex',
    gap: anatomy['space-8'],
    alignItems: 'center',
    padding: anatomy['space-12'],
    paddingRight: anatomy['space-20'],
    fontSize: typography['fontSizeBody-3'],
    lineHeight: typography['lineHeightBody-3'],
    color: colors.accentText,
    borderRadius: anatomy.borderRadiusS,
    background: '#232A32',
    transition: 'color 0.2s ease-in-out',
    cursor: 'pointer',
    ':hover': {
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #232A32',
    },
    ':disabled': {
      opacity: 0.6,
    },
  },
  editableButtonText: {
    background: 'transparent',
    border: 'none',
    outline: 'none',
    padding: 0,
    fontSize: typography['fontSizeBody-3'],
    lineHeight: typography['lineHeightBody-3'],
    color: colors.accentText,
    wordBreak: 'break-word',
  },
  editableButtonTextPreview: {
    cursor: 'pointer',
  },
  editableButtonTextEdit: {
    cursor: 'text',
  },
});
